(() => {
  if (customElements.get('dl-page-flip-card')) return;

  class DlPageFlipCard extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-flip-card]'));
      this.overlay = this.querySelector('[data-flip-overlay]');
      this.abortController = new AbortController();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    bindEvents() {
      const signal = this.abortController.signal;

      this.cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          this.setActive(card.classList.contains('is-active') ? null : card);
        }, { signal });
      });

      this.overlay?.addEventListener('click', () => this.setActive(null), { signal });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('has-active-card')) this.setActive(null);
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target?.closest?.('[data-flip-card]');
        if (card && this.contains(card)) this.setActive(card);
      }, { signal });

      document.addEventListener('shopify:block:deselect', (event) => {
        const card = event.target?.closest?.('[data-flip-card]');
        if (card && this.contains(card) && card.classList.contains('is-active')) this.setActive(null);
      }, { signal });
    }

    setActive(activeCard) {
      this.classList.toggle('has-active-card', Boolean(activeCard));
      this.overlay?.setAttribute('tabindex', activeCard ? '0' : '-1');

      this.cards.forEach((card) => {
        const active = card === activeCard;
        card.classList.toggle('is-active', active);
        const trigger = card.querySelector('[data-flip-trigger]');
        trigger?.setAttribute('aria-expanded', String(active));
        trigger?.setAttribute('tabindex', active ? '-1' : '0');
        card.querySelector('[data-flip-back]')?.setAttribute('aria-hidden', String(!active));
        card.querySelector('[data-flip-link]')?.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (activeCard && window.innerWidth <= 990) {
        activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  }

  customElements.define('dl-page-flip-card', DlPageFlipCard);
})();
